class UserData {
  constructor() {
    this.namespaced = true;
    this.state = {
      userData: {
        smoke: '',
        givenBirth:'',
        radioActiveIodine:'',
        eyeTrauma:'',
        genderMale:'',
        age40:'',
        conditions:'',
        covid:'',
        covidVaccination:'',
        isWhatTed: false,
        isEnvironment :false,
        isGenetics: false,
        isGender:  false,
        email: '',
        isEmailSent: false
      }
    };

    this.getters = {
      userData: state => {
        return state.userData;
      },
    };

    this.mutations = {
      saveUserData: (state, { data, section }) => {
        state.userData[section] = data;
      },
      resetSections: (state) => {
        state.userData = {
        }
      },
    };

    this.actions = {
      saveUserData: ({ commit }, { data, section }) => {
        commit('saveUserData', { data, section });
      },
      resetSections: ({ commit }) => {
        commit('resetSections');
      },

    };
  }
}

export default UserData;
